"use strict";

exports.__esModule = true;
exports.shouldOpenPreferencesModal = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
const shouldOpenPreferencesModal = ({
  service,
  isDummy = false,
  isMultiServiceAppointmentEnabled,
  experiments
}) => {
  if (service.type !== _types.ServiceType.APPOINTMENT) {
    return false;
  }
  const hasMultiServiceAppointments = !isDummy && isMultiServiceAppointmentEnabled;
  const hasDynamicDuration = hasServiceDynamicDuration(service);
  const hasAddOns = hasServiceAddOns(service, experiments);
  return hasMultiServiceAppointments || hasDynamicDuration || hasAddOns;
};
exports.shouldOpenPreferencesModal = shouldOpenPreferencesModal;
const hasServiceAddOns = (service, experiments) => {
  var _service$addOnGroups;
  return experiments.enabled('specs.bookings.AddonsUOU') && !!((_service$addOnGroups = service.addOnGroups) != null && _service$addOnGroups.some(group => {
    var _group$addOnIds;
    return (_group$addOnIds = group.addOnIds) == null ? void 0 : _group$addOnIds.length;
  }));
};
const hasServiceDynamicDuration = service => {
  var _service$schedule;
  const durations = ((_service$schedule = service.schedule) == null || (_service$schedule = _service$schedule.availabilityConstraints) == null ? void 0 : _service$schedule.durations) || [];
  return durations.length > 1;
};
//# sourceMappingURL=shouldOpenPreferencesModal.js.map